import React from 'react';

const LockIcon = ({ className = '' }: { className?: string }) => (
	<svg
		width="7"
		height="8"
		viewBox="0 0 7 8"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M6.5625 3.4375H5.89844V1.25C5.89844 0.55957 5.33887 0 4.64844 0H2.22656C1.53613 0 0.976562 0.55957 0.976562 1.25V3.4375H0.3125C0.139648 3.4375 0 3.57715 0 3.75V7.5C0 7.67285 0.139648 7.8125 0.3125 7.8125H6.5625C6.73535 7.8125 6.875 7.67285 6.875 7.5V3.75C6.875 3.57715 6.73535 3.4375 6.5625 3.4375ZM3.71094 5.75195V6.26953C3.71094 6.3125 3.67578 6.34766 3.63281 6.34766H3.24219C3.19922 6.34766 3.16406 6.3125 3.16406 6.26953V5.75195C3.08345 5.69408 3.02328 5.61212 2.99222 5.51787C2.96115 5.42362 2.96079 5.32194 2.99119 5.22748C3.02159 5.13301 3.08118 5.05063 3.16138 4.99218C3.24159 4.93374 3.33826 4.90225 3.4375 4.90225C3.53674 4.90225 3.63341 4.93374 3.71362 4.99218C3.79382 5.05063 3.85341 5.13301 3.88381 5.22748C3.91421 5.32194 3.91385 5.42362 3.88278 5.51787C3.85172 5.61212 3.79155 5.69408 3.71094 5.75195V5.75195ZM5.19531 3.4375H1.67969V1.25C1.67969 0.948242 1.9248 0.703125 2.22656 0.703125H4.64844C4.9502 0.703125 5.19531 0.948242 5.19531 1.25V3.4375Z"
			fill="white"
		/>
	</svg>
);

export default LockIcon;
